// extracted by mini-css-extract-plugin
module.exports = {"Container":"modal-dialog-body_Container__Kz9kN"};